export enum ProcessStatusEnum {
  PENDING = "Pending",
  WAITING_FOR_PAYMENT = "Waiting for action",
  IN_PROGRESS = "In Progress",
  REJECTED = "Rejected",
  DONE = "Done",
  CANCELED = "Canceled",
}

export enum FraudTypeEnum {
  INVESTMENTS = "INVESTMENTS",
  PHISHING = "PHISHING",
  ROMANCE = "ROMANCE",
  CRYPTO = "CRYPTO",
  JOB = "JOB",
  ELSE = "ELSE",
}

export enum CryptoNetworkEnum {
  BTC = "BTC",
  ETH = "ETH",
  TRON = "TRON",
}

export enum PaymentMethod {
  CARD = "CARD",
  WIRE = "WIRE",
  CRYPTO = "CRYPTO",
  ELSE = "ELSE",
}

export enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "IN_ACTIVE",
}

export enum StatusChangeOptions {
  WAITING_FOR_PAYMENT = "WAITING_FOR_PAYMENT",
  REJECTED = "REJECTED",
}

export enum StatusAltEnum {
  Pending = "We have received your request, our teams will review it and will go back to you with our decision.",
  InProgress = "Our team is currently working on your request.",
  Waitingforactions = "Our team is working on your request, but there is still payment to be completed. Please complete the payment before we can send you the final delivery.",
  Done = "Our team has finished our work and your development is ready!",
}

export enum PayType {
  FULL_PAY = "FULL_PAY",
  PARTIAL_PAY = "PARTIAL_PAY",
}

export enum WalletType {
  BTC = "bitcoin",
  TRON = "tron",
  ETH = "ethereum",
}

export enum GenericErrors {
  UNAVAILABLE_INFORMATION = "Some information is currently unavailable. Please try again later.",
}
